import { Controller } from "@hotwired/stimulus"

// ゲームの本体（文言・音・演出）は、この controller が繋がった画面でだけ読み込む
export default class extends Controller {
  static values = { newResultUrl: String }

  async connect() {
    const { mountGame } = await import("../bengoshi_map_game/ui")
    if (!this.element.isConnected || this.unmount) return

    this.unmount = mountGame(this.element, { newResultUrl: this.newResultUrlValue })
  }

  disconnect() {
    this.unmount?.()
    this.unmount = null
  }
}
